import React, { FunctionComponent } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { TranslateProp } from '../../../common-types';
import Theme from '../../../theme';
import { defaultScale, scaleText } from '../../../utils';

interface IProps {
  header: string;
  subHeader: string;
}

const LeaderboardOverviewInfo: FunctionComponent<IProps> = (
  {
    header,
    subHeader,
  },
) => {
  return (
    <View style={{width: '100%'}}>
      <View style={styles.textContainer}>
        <Text style={styles.weightText}>
          {header}
        </Text>
      </View>
      <Text style={styles.subText}>
        {subHeader}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  weightText: {
    fontFamily: Theme.Weight700,
    fontSize: scaleText(24),
    color: Theme.BLACK,
  },
  lightText: {
    display: 'flex',
    fontFamily: Theme.Weight500,
    fontSize: scaleText(16),
    color: Theme.GREY,
    alignSelf: 'flex-end',
    paddingBottom: defaultScale(2),
  },
  textContainer: {
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
  subText: {
    ...Theme.textStyle.small,
    marginTop: defaultScale(2),
  },
  superScriptMuted: {
    ...Theme.textStyle.bodyCopyReg,
    color: Theme.GREY,
    fontFamily: Theme.Weight500,
    alignSelf: 'flex-start',
    marginLeft: defaultScale(2),
  },
});

export default LeaderboardOverviewInfo;
